export const optionsDC2B = {
  CameraMode: [
    { value: 1, label: 'Photo (Default)' },
    { value: 2, label: 'Video' },
    { value: 3, label: 'PIC+Video' },
  ],

  PictureSize: [
    { value: 1, label: '5MP (Default)' },
    { value: 2, label: '8MP' },
    { value: 3, label: '12MP' },
    { value: 4, label: '16MP' },
    { value: 5, label: '24MP' },
    { value: 6, label: '32MP' },
  ],

  PirSensitivity: [
    { value: 1, label: '1 (Lowest)' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5 (Default)' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9 (Highest)' },
  ],

  Cellular: [
    { value: 0, label: '4 Times Daily (Default)' },
    { value: 1, label: 'Always Available' },
  ],

  MultiShot: [
    { value: 1, label: '1 Picture (Default)' },
    { value: 2, label: '2 Pictures' },
    { value: 3, label: '3 Pictures' },
    { value: 4, label: '4 Pictures' },
    { value: 5, label: '5 Pictures' },
  ],

  BurstInterval: [
    { value: 0, label: '0s' },
    { value: 1, label: '1s (Default)' },
    { value: 2, label: '2s' },
    { value: 3, label: '3s' },
  ],

  SendingMode0: [
    { value: 0, label: 'Immediately (Default)' },
    { value: 1, label: 'Every 1H' },
    { value: 2, label: 'Every 4H' },
  ],

  SendingMode1: [
    { value: 0, label: 'Immediately (Default)' },
  ],

  IRFlash: [
    { value: 1, label: 'Near' },
    { value: 2, label: 'Far (Default)' },
  ],

  VideoSending: [
    { value: 1, label: 'Full Video' },
    { value: 2, label: 'Thumbnail Image' },
  ],

  VideoSize: [
    { value: 1, label: 'WVGA (Default)' },
    { value: 2, label: '720P' },
    { value: 3, label: '1080P' },
  ],

  VideoLength: [
    { value: 1, label: '5s (Default)' },
    { value: 2, label: '10s' },
    { value: 3, label: '15s' },
  ],

  VideoLengthAfterF1T2: [
    { value: 1, label: '5s (Default)' },
    { value: 2, label: '10s' },
    { value: 3, label: '15s' },
    { value: 4, label: '20s' },
    { value: 5, label: '30s' },
  ],

  PirSwitch: [
    { value: 0, label: 'ON (default)' },
    { value: 1, label: 'OFF' },
  ],

  ImageTransmitted: [
    { value: 1, label: 'Small' },
    { value: 2, label: 'Medium (default)' },
    { value: 3, label: 'Large' },
  ],

  ColorMode: [
    { value: 0, label: 'Standard (default)' },
    { value: 1, label: 'Low Daylight' },
    { value: 2, label: 'Bright Daylight' },
  ],

  SmartDetection: [
    { value: -1, label: 'OFF (default)' },
    { value: 0, label: 'Person' },
    { value: 1, label: 'Vehicle/ATV' },
    { value: 2, label: 'Bear' },
    { value: 3, label: 'Deer' },
    { value: 4, label: 'Horse' },
    { value: 5, label: 'Hog' },
    { value: 6, label: 'Turkey' },
    { value: 7, label: 'Raccoon' },
    { value: 8, label: 'Cow' },
    { value: 9, label: 'Sheep' },
    { value: 10, label: 'Dog/Canine' },
    { value: 11, label: 'Squirrel' },
    { value: 12, label: 'Skunk' },
    { value: 13, label: 'Cat/Feline' },
    { value: 14, label: 'Rabbit' },
    { value: 15, label: 'Bird' },
  ],
};
